import styled from 'styled-components';
import { theme } from '@dls/web';

export const LoginCheckoutWrapper = styled.div`
  @media (max-width: ${theme.breakpoints[1]}) {
    padding: 0px 16px;
  }
`;
